import React from 'react';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const AlertPopup = _ref => {
  let {
    onHide,
    show,
    message,
    messageBody,
    buttonProps = [],
    heading = undefined
  } = _ref;
  const renderMessage = () => {
    if (messageBody != null) {
      return /*#__PURE__*/React.createElement("div", {
        className: "text-center pb-k d-flex flex-column align-items-center gap-2"
      }, messageBody);
    }
    return /*#__PURE__*/React.createElement("h3", {
      className: "text-center pb-k"
    }, message);
  };
  const modalBody = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column justify-content-center p-6"
  }, heading && /*#__PURE__*/React.createElement("h1", {
    className: "text-center pb-k mb-3"
  }, heading), renderMessage(), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, buttonProps.map((_ref2, index) => {
    let {
      text,
      buttonAction,
      className,
      buttonVariant
    } = _ref2;
    return /*#__PURE__*/React.createElement(Button, {
      key: index,
      variant: buttonVariant,
      className: className,
      size: "lg",
      onClick: () => {
        buttonAction();
        onHide();
      }
    }, text);
  }))))));
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    renderBody: () => modalBody,
    onHide: onHide,
    renderFooter: () => {} // to avoid rendering footer empty function passed
  });
};
export default AlertPopup;